import React from "react";
import SectionWrapper from "../../components/ui/SectionWrapper";

const PrivacyPolicy: React.FC = () => {
  return (
    <SectionWrapper>
      <div className="mb-[100px] overflow-hidden rounded-b-lg bg-[#F2F4F7]">

        {/* ===== TOP GRID SECTION ===== */}
        <div className="flex flex-col lg:flex-row">

          {/* IMAGE (TOP ON MOBILE, RIGHT ON DESKTOP) */}
          <div className="flex justify-center lg:justify-end order-1 lg:order-2">
            <div className="relative w-full h-[220px] sm:h-[280px] lg:w-[300px] lg:h-[600px] overflow-hidden">
             <img
                src="/assets/optimized/privacy-policy-1200.jpg"
                alt="Privacy Policy of Consumer Cloud Services"
                loading="eager"
                decoding="async"
                className="
                    w-full h-full object-cover
                    lg:object-center
                    lg:w-auto lg:h-full lg:max-w-none
                    lg:scale-[90%] lg:-translate-y-6
                    lg:mt-[-20px]
                "
                />
            </div>
          </div>

          {/* LEFT CONTENT */}
          <div className="flex-1 px-8 py-8 text-[15px] text-gray-800 space-y-8 order-2 lg:order-1">

            <p>
              The following statement explains Consumer Cloud Services' policy
              regarding the use and protection of personal information we collect
              about you when you use this website and any website from which we
              operate our products and services. We may update our privacy policy
              from time to time and therefore you should check this page
              periodically. This privacy policy is effective from 05/2015
            </p>

            <div className="space-y-1">
              <p>Statement of intent</p>
              <p>Information on visitors</p>
              <p>Submitting personal information</p>
              <p>Access to your personal information</p>
              <p>Direct marketing and user surveys</p>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-[#0B2545]">
                1. Statement of Intent
              </h3>
              <p className="mt-2">
                To use this website and its services you need to provide personal
                information about yourself (e.g. name and e-mail address etc).
                By providing details for the fields requested, you will enable
                Consumer Cloud Services to provide you with the services you
                select. Whenever you provide such personal information, we will
                treat that information in accordance with this policy.
              </p>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-[#0B2545]">
                2. Information on visitors
              </h3>
              <p className="mt-2">
                We use cookies for certain areas of our website. Cookies are files
                that store information on your hard drive or browser and are
                placed on your computer by websites you visit. One of the cookies
                we use is essential for Consumer Cloud Services to operate
                securely and is set during log on.
              </p>
            </div>

          </div>
        </div>

        {/* ===== FULL WIDTH SECTION (NO GRID) ===== */}
        <div className="px-8 py-8 text-[15px] text-gray-800 space-y-8">

          <p>The table below explains to cookies we use and why:</p>

          <div className="overflow-x-auto">
            <table className="min-w-full border border-gray-300 text-left text-sm">
              <thead className="bg-gray-100">
                <tr>
                  <th className="border px-4 py-2 font-semibold">Cookie</th>
                  <th className="border px-4 py-2 font-semibold">Purpose</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="border px-4 py-2">
                    E-Mail address recollection cookie
                  </td>
                  <td className="border px-4 py-2">
                    This cookie remembers a user's e-mail address as part of
                    the log in process when visiting Consumer Cloud Services.
                  </td>
                </tr>
                <tr>
                  <td className="border px-4 py-2">
                    Website session cookie
                  </td>
                  <td className="border px-4 py-2">
                    This cookie is essential to enable our Consumer Cloud
                    Services to operate securely. The session cookie
                    automatically expires when a user closes their browser
                    or after 7.5 hours of inactivity.
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div>
            <h3 className="text-lg font-semibold text-[#0B2545]">
              3. Submitting personal information
            </h3>
            <p className="mt-2">
              If you supply any personal information to Consumer Cloud Services
              for the purpose referred to in section 1 above, we have legal
              obligations towards you in the way that we deal with that data.
            </p>
          </div>

          <div>
            <h3 className="text-lg font-semibold text-[#0B2545]">
              4. Access to your personal information
            </h3>
            <p className="mt-2">
              You have the right to request a copy of the personal information
              which Consumer Cloud Services holds about you.
            </p>
          </div>

          <div>
            <h3 className="text-lg font-semibold text-[#0B2545]">
              5. Direct marketing and user surveys
            </h3>
            <p className="mt-2">
              We would like to provide you with information about new products
              and services that may be of interest to you.
            </p>
          </div>

        </div>
      </div>
    </SectionWrapper>
  );
};

export default PrivacyPolicy;
